import { render, staticRenderFns } from "./OpportunityList.vue?vue&type=template&id=4558718a&scoped=true&"
import script from "./OpportunityList.vue?vue&type=script&lang=js&"
export * from "./OpportunityList.vue?vue&type=script&lang=js&"
import style0 from "./OpportunityList.vue?vue&type=style&index=0&id=4558718a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4558718a",
  null
  
)

export default component.exports